import { createSelector } from '@reduxjs/toolkit';
import { ESRI_MAP } from '@rsos/capstone/src/constants/capabilities';
import { PREMIUM_ESRI_MAP } from '@rsos/constants/permissions';

/**
 * Determines if the current user has both `ESRI_MAP` capability and permissions enabled.
 * @param {Object} state - redux state
 * @param {Object} state.psaps - PSAPS reducer
 * @param {Object} state.sinatra - Sinatra reducer
 */
const checkEsriMapAccess = createSelector(
  state => state,
  state => {
    const isCapabilityEnabled =
      !!state.psaps?.currentPSAP?.activeCapabilities?.[ESRI_MAP];

    const isPermissionEnabled =
      state.sinatra?.user?.currentRole?.permissions?.includes(PREMIUM_ESRI_MAP);

    return isCapabilityEnabled && isPermissionEnabled;
  },
);

export default checkEsriMapAccess;
